module.exports = __webpack_public_path__ + "static/media/warning_512.818b2701.png";